import { render } from "./BarcodePDF.vue?vue&type=template&id=2f2aef31&scoped=true"
import script from "./BarcodePDF.vue?vue&type=script&lang=ts"
export * from "./BarcodePDF.vue?vue&type=script&lang=ts"

import "./BarcodePDF.vue?vue&type=style&index=0&id=2f2aef31&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f2aef31"

export default script